import { useState, useRef } from "react";
import styled from "styled-components";

//Import UI components to be used
import { Form } from '../form/FormComponents';
import SelectModal from "./SelectModal";
import SelectInput from "./SelectInput";

//setup for language State
import useTranslation from "../../hooks/useTranslation";
import { useModalStack } from "../../context/modalStackContext";


const SearchContainer = styled.div`
    height: "100%";

    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: ${(props) => props.$alwaysOn ? 'block' : 'none'};
        
    }
    
`

const AdditionalInfo = styled.div`
    font-size: 0.8rem;
    color: ${({ theme }) => theme.font.color};
    margin-top: 0.25rem;
    padding-left: 0.5rem;
    display:  'block' ;
`

const SelectControl_m = ({
    data, onSelect, placeholder, valueId, valueName, entity,
    modalTitle, isRed, $alwaysOn, options = {},
    defaultValue,
    additionalInfo = null,
    name,
    labelId,
    testId,
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const searchContainer = useRef(null);
    const { t } = useTranslation()

    const { pushModal } = useModalStack();

    const displayName = valueName || defaultValue?.name || '';

    //Hide & Show the Menu
    const showModal = () => {
        pushModal(SelectModal, {
            isVisible: true,
            setIsVisible: setIsVisible,
            data,
            valueName,
            onSelect,
            valueId,
            entity,
            modalTitle,
            options,
            defaultValue,
            testId,
        });
        setIsVisible(true);
    }

    return (
        <SearchContainer ref={searchContainer} $alwaysOn={$alwaysOn}>
            <Form.Group >
                <SelectInput
                    readonly
                    type="text"
                    valueId={valueId || ''}
                    valueName={displayName}
                    name={name || `${entity}Name`}
                    showModal={showModal}
                    placeholder={t(placeholder)}
                    isRed={isRed}
                    labelId={labelId}
                    testId={`${testId}.mobile`}
                />
            </Form.Group>
            {additionalInfo && <AdditionalInfo>
                {additionalInfo}
            </AdditionalInfo>}
            {/* Modal is now managed by the modal stack context */}
        </SearchContainer>
    );
};

export default SelectControl_m;
